module.exports = __webpack_public_path__ + "cb4f5bd6e42048cbab4221b70425436d.pdf";